import React, { useState } from 'react';
import { uniqueId } from 'lodash';
import cn from 'classnames';
import { Text, TEXT_VARIANTS } from '../Typography';

const TextField = React.forwardRef(
  (
    {
      ariaLabel,
      title,
      className,
      label,
      onChange,
      onKeyDown,
      placeholder,
      value,
      whiteBackground,
      disabled,
      required,
      maxLength,
      labelVariant,
      questionElement,
      ...props
    },
    ref,
  ) => {
    const [id] = useState(uniqueId('uiTextFieldLabel-'));
    const hasClassName = !!className;

    const textClassName = cn('TextField', {
      'TextField-whiteBackground': whiteBackground,
      'u-bggray-lighter': !whiteBackground,
      'TextField-disabled': disabled,
      'EditorElement-input llui-text-subheader-bold UnifiedPromptInput':
        questionElement,
      [className]: hasClassName,
    });

    return (
      <div className="pos-r">
        {label && (
          <Text
            className="pt-8 d-f"
            variant={labelVariant || TEXT_VARIANTS.TAG_BOLD}
            id={id}
          >
            {label}
            {required && <div className="c-danger-red pl-4">*</div>}
          </Text>
        )}
        <input
          ref={ref}
          type="text"
          aria-label={ariaLabel}
          aria-labelledby={id}
          title={title}
          placeholder={placeholder}
          className={textClassName}
          onChange={onChange}
          onKeyDown={onKeyDown}
          value={value}
          disabled={disabled}
          maxLength={maxLength}
          {...props}
        />
        {maxLength && (
          <Text
            className="pos-a TextField-count"
            variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
          >
            {value.length}/{maxLength}
          </Text>
        )}
      </div>
    );
  },
);

export default TextField;
